export default {
      id: "segment__full_half_half-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#segment__full_half_half",
      toString: function () {
        return this.url;
      }
    }